<template>
  <div class="products-tab">
    <section class="page-head">
      <div class="container reveal">
        <h1>全栈数字化解决方案</h1>
        <p>从硬件安装到软件研发，从线下场域到线上政务，我们提供一站式、全周期的闭环服务。</p>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <article class="row reveal">
          <div class="copy">
            <small>核心产品</small>
            <h2>中鸿小门神智慧指挥中枢</h2>
            <p>
              该项目是企业自身发展的技术突破升级，更是响应“提升城市精细化管理水平”战略部署的创新实践。
              致力于将传统停车、门禁、监控管理升级为城市现代化治理的重要组成部分。
            </p>
            <div class="features">
              <div><b>预警化协同</b><span>多维度数据分析，实现事前预警与即时响应。</span></div>
              <div><b>联动枢纽</b><span>将分散的管理节点升级为高效协同网络。</span></div>
            </div>
            <!-- <button type="button" class="link-btn">获取详细产品手册</button> -->
          </div>
          <img src="@/assets/product/product_home.png" />
        </article>

        <article class="row reverse reveal">
          <div class="copy">
            <small>政务数字化</small>
            <h2>政务软件全生命周期开发</h2>
            <p>
              聚焦政府部门数字化转型痛点，提供从需求调研到运维保障的全周期服务。
              我们在复杂场景下的定制化能力，已获得多个地市政府高度认可。
            </p>
            <ul class="case-list">
              <li>钱江三桥临时渡口管理系统</li>
              <li>“协商铃”政企沟通平台</li>
              <li>上塘 CityWalk 文旅数字化看板</li>
            </ul>
          </div>
          <img src="@/assets/product/products-government.png" />
        </article>

        <article class="row reveal">
          <div class="copy">
            <small class="green">智慧出行配套</small>
            <h2>新能源充电桩实施安装</h2>
            <p>
              配套智慧停车生态，我们提供高标准充电桩施工与集成管理方案。
              通过智能化调度系统，提升桩站使用率，缓解城市充电压力。
            </p>
            <div class="highlight">
              <b>标杆案例：新汇石人才公寓充电站</b>
              <span>实现 100% 覆盖，配套智能监控与自助缴费系统。</span>
            </div>
          </div>
          <img src="@/assets/product/products-charge.png" />
        </article>
      </div>
    </section>

    <section class="section white">
      <div class="container">
        <header class="section-head center reveal">
          <h2>标准化服务交付体系</h2>
        </header>
        <div class="process-grid">
          <article v-for="item in process" :key="item.title" class="process-card reveal">
            <img class="icon" :src="item.icon" />
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </article>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import cases from '@/assets/product/case.png'
import demand from '@/assets/product/demand.png'
import system from '@/assets/product/system.png'
import tool from '@/assets/product/tool.png'

export default {
  name: 'ProductsTab',
  data() {
    return {
      process: [
        { icon: demand, title: '需求调研', desc: '深入业务一线，洞察真实痛点，确保方案针对性。' },
        { icon: cases, title: '方案设计', desc: '专业架构师领衔，打造高扩展、高可用系统蓝图。' },
        { icon: system, title: '系统开发', desc: '敏捷开发模式，100% 还原设计需求，确保交付质量。' },
        { icon: tool, title: '运维保障', desc: '7×24 小时响应机制，定期系统迭代与安全检查。' }
      ]
    }
  }
}
</script>

<style scoped lang="less">
.container {
  width: min(1240px, calc(100% - 48px));
  margin: 0 auto;
}

.page-head {
  padding: 70px 0;
  color: #fff;
  background: #081431;
}

.page-head h1 {
  margin: 0 0 10px;
  font-size: clamp(32px, 3.8vw, 48px);
}

.page-head p {
  margin: 0;
  color: #a8b8d1;
  max-width: 760px;
  line-height: 1.7;
}

.section {
  padding: 62px 0;
}

.section.white {
  background: #fff;
}

.row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  align-items: center;
  margin-bottom: 30px;
}

.row:last-child {
  margin-bottom: 0;
}

.row.reverse .copy {
  order: 2;
}

.row.reverse img {
  order: 1;
}

.row img {
  width: 100%;
  // height: 292px;
  border-radius: 24px;
  border: 1px solid #dde7f7;
  background: #fff;
  box-shadow: 0 16px 26px rgba(18, 46, 95, 0.12);
  transition: transform 0.55s ease, box-shadow 0.3s ease;
}

.copy small {
  color: #2f67ea;
  font-weight: 700;
  letter-spacing: 0.8px;
}

.copy small.green {
  color: #2f9b59;
}

.copy h2 {
  margin: 10px 0 12px;
  font-size: clamp(26px, 2.8vw, 38px);
}

.copy p {
  margin: 0;
  color: #5f7591;
  line-height: 1.85;
}

.features {
  margin-top: 14px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.features div {
  border: 1px solid #dce7f9;
  border-radius: 12px;
  padding: 10px;
  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
}

.features b {
  display: block;
  margin-bottom: 4px;
}

.features span {
  color: #66809f;
  font-size: 13px;
  line-height: 1.6;
}

.features div:hover {
  transform: translateY(-3px);
  border-color: #c7daf8;
  box-shadow: 0 10px 18px rgba(21, 53, 104, 0.1);
}

.link-btn {
  margin-top: 16px;
  border: 0;
  background: none;
  color: #2f67ea;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.2s ease, color 0.2s ease;
}

.link-btn:hover {
  transform: translateX(2px);
  color: #1c52cf;
}

.case-list {
  margin: 14px 0 0;
  padding: 0;
  list-style: none;
}

.case-list li {
  border: 1px solid #e0eaf8;
  border-radius: 12px;
  min-height: 44px;
  display: flex;
  align-items: center;
  padding: 0 14px;
  margin-bottom: 8px;
  color: #415c81;
  transition: all 0.22s ease;
}

.case-list li::after {
 // content: '›';
  margin-left: auto;
  color: #95a6bf;
}

.case-list li:hover {
  border-color: #c8daf8;
  transform: translateX(2px);
  box-shadow: 0 8px 16px rgba(22, 54, 107, 0.08);
}

.highlight {
  margin-top: 16px;
  border: 1px solid #c8ebd2;
  border-radius: 12px;
  background: #eaf8ef;
  padding: 12px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.highlight b {
  display: block;
  color: #0f6030;
}

.highlight span {
  display: block;
  margin-top: 4px;
  color: #34734f;
  font-size: 13px;
}

.highlight:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(23, 86, 47, 0.12);
}

.center {
  text-align: center;
}

.section-head h2 {
  margin: 0;
  font-size: clamp(26px, 2.8vw, 38px);
}

.process-grid {
  margin-top: 28px;
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.process-card {
  text-align: center;
  border: 1px solid #e0e9f8;
  border-radius: 16px;
  padding: 18px;
  background: #fff;
  transition: transform 0.24s ease, box-shadow 0.24s ease, border-color 0.24s ease;
}

.process-card .icon {
  width: 42px;
  height: 42px;
  border-radius: 13px;
  margin: 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  // background: #eaf2ff;
  color: #2f67ea;
  font-weight: 700;
}

.process-card h3 {
  margin: 12px 0 8px;
  font-size: 18px;
}

.process-card p {
  margin: 0;
  color: #657d9a;
  line-height: 1.7;
}

.process-card:hover {
  transform: translateY(-5px);
  border-color: #c7daf8;
  box-shadow: 0 14px 24px rgba(21, 52, 102, 0.12);
}

.row:hover img {
  transform: scale(1.03);
  box-shadow: 0 20px 32px rgba(18, 46, 95, 0.16);
}

@media (max-width: 1024px) {
  .container {
    width: min(1240px, calc(100% - 36px));
  }

  .row,
  .features {
    grid-template-columns: 1fr;
  }

  .row.reverse .copy,
  .row.reverse img {
    order: initial;
  }

  .process-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .container {
    width: min(1240px, calc(100% - 24px));
  }

  .copy p,
  .features span,
  .process-card p {
    font-size: 14px;
  }

  .process-grid {
    grid-template-columns: 1fr;
  }
}
</style>
